import WebLayout from './BriefcaseCheckboxLayout.web';
import MobileLayout from './BriefcaseCheckboxLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
